import translationFR from "./fr/translation.json"
import translationEN from "./en/translation.json"

export default {
  fr: { translation: translationFR },
  en: { translation: translationEN },
}
